export const CDFI_CATEGORIES = {
  CIA: { display: 'Custom Investment Area (CIA)', server: 'CIA' },
  IA: { display: 'Investment Area (IA)', server: 'IA' },
  LITP: { display: 'Low-income Target Population (LITP)', server: 'LITP' },
  OTP: { display: 'Other Targeted Population (OTP)', server: 'OTP' },
  AfricanAmerican: {
    display: 'African American (OTP)',
    server: 'African American',
  },
  Hispanic: { display: 'Hispanic (OTP)', server: 'Hispanic' },
  NativeAmerican: {
    display: 'Native American (OTP)',
    server: 'Native American',
  },
  NativeAlaskan: { display: 'Native Alaskan (OTP)', server: 'Native Alaskan' },
  NativeHawaiian: {
    display: 'Native Hawaiian (OTP)',
    server: 'Native Hawaiian',
  },
  OtherPacificIslander: {
    display: 'Other Pacific Islander (OTP)',
    server: 'Other Pacific Islander',
  },
  Filipino: { display: 'Filipino (OTP)', server: 'Filipino' },
  Vietnamese: { display: 'Vietnamese (OTP)', server: 'Vietnamese' },
  PersonsWithDisabilities: {
    display: 'Persons with Disabilities (OTP)',
    server: 'Persons with Disabilities',
  },
  CertifiedCDFIs: {
    display: 'Certified CDFIs (OTP)',
    server: 'Certified CDFIs',
  },
};
